import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "dino", title: tk("Dino Kejar"), tone: "from-amber-500 to-orange-600", emoji: "🦖", w: 360, h: 520, speak: true,
  intro: tk("Jadi Dino dan kejar Harraz dan Hannah di padang pasir! Dengar soalan, lari di bawah jawapan yang betul untuk mendekati mereka. Lompat kaktus dan elak burung."),
  hint: tk("Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat kaktus."),
  topics: [{ id: "bm", label: tk("Bahasa Melayu") }, { id: "bi", label: tk("Bahasa Inggeris") }],
  noteLabel: tk("Jarak"),
  load: async () => (await import("./engines/dino3d")).createDino3d,
};
export const DinoKejarPage = () => <ArcadePage spec={SPEC} />;
